export const triStateBoolean = [
  { id: 2, name: 'Yes' },
  { id: 3, name: 'No' },
];